import axios from 'axios';
import { API_BASE_URI } from 'library/constants/api';

const API_BASE_URL = `${API_BASE_URI}/pricing`;

const PricingService = {
  // Function to get data from the API for amenities
  getAdditionalPriceOptionsList: async () => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };

    try {
      const response = await axios
        .get(
          //`${API_BASE_URL}v3/7a93735f-9e54-4cb6-8d2a-5da904b1540f`,
          `${API_BASE_URL}/getAdditionalPriceOptionsList`,
          { headers },
        )
        .catch((error) => {
          if (error?.response?.status === 403) {
            localStorage.clear();
            sessionStorage.clear();
            window.open('/sign-in', '_self');
          }
          throw error;
        });
      return response.data;
    } catch (error) {
      // Handle error
      console.error('Error fetching data:', error);
      throw error;
    }
  },

  getPropertyPricingDetails: async (propertyId) => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    try {
      const cacheBust = `_t=${Date.now()}`;
      const response = await axios
        .get(
          `${API_BASE_URL}/getPropertyPricingDetails?propertyId=${propertyId}&${cacheBust}`,
          { headers },
        )
        .catch((error) => {
          if (error?.response?.status === 403) {
            localStorage.clear();
            sessionStorage.clear();
            window.open('/sign-in', '_self');
          }
          throw error;
        });
      return response.data;
    } catch (error) {
      // Handle error
      console.error('Error fetching data:', error);
      throw error;
    }
  },

  // Function to post data to the API
  savePropertyCalendarPricingDetails: async (data) => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };

    try {
      const response = await axios
        .post(`${API_BASE_URL}/savePropertyCalendarPricingDetails`, data, { headers })
        .catch((error) => {
          if (error?.response?.status === 403) {
            localStorage.clear();
            sessionStorage.clear();
            window.open('/sign-in', '_self');
          }
          throw error;
        });
      return response.data;
    } catch (error) {
      // Handle error
      console.error('Error posting data:', error);
      throw error;
    }
  },

  /**
   * Saves pricing settings and the calendar dates in the request, which may be none (a settings-only save). Unlike
   * updatePropertyCalendarPricingDetails, which refuses an empty list of dates.
   */
  updatePropertyPricingDetails: async (data) => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };

    try {
      const response = await axios
        .post(`${API_BASE_URL}/updatePropertyPricingDetails`, data, { headers })
        .catch((error) => {
          if (error?.response?.status === 403) {
            localStorage.clear();
            sessionStorage.clear();
            window.open('/sign-in', '_self');
          }
          throw error;
        });
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  },

  updatePropertyCalendarPricingDetails: async (data) => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };

    try {
      const response = await axios
        .post(`${API_BASE_URL}/updatePropertyCalendarPricingDetails`, data, { headers })
        .catch((error) => {
          if (error?.response?.status === 403) {
            localStorage.clear();
            sessionStorage.clear();
            window.open('/sign-in', '_self');
          }
          throw error;
        });
      return response.data;
    } catch (error) {
      // Handle error
      console.error('Error posting data:', error);
      throw error;
    }
  },
  /** The property's single "X% off within N days of check-in" rule; result.percent 0 means off. */
  getLastMinuteDiscount: async (propertyId) => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` };
    const response = await axios.get(`${API_BASE_URL}/getLastMinuteDiscount`, {
      headers,
      params: { propertyId, _t: Date.now() },
    });
    return response.data;
  },

  saveLastMinuteDiscount: async (data) => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      'Content-Type': 'application/json',
    };
    const response = await axios.post(`${API_BASE_URL}/saveLastMinuteDiscount`, data, { headers });
    return response.data;
  },
  // Add more functions for other API calls as needed
};

export default PricingService;
